/*
 * Roller add-on cart dependency.
 * Houdt de Electric Roller Shutter gekoppeld aan zijn 'parent' product:
 * zodra het bijbehorende product (swim spa) uit de cart verdwijnt, wordt de
 * roller-regel automatisch ook verwijderd. De koppeling zit in de line-item
 * property `_addon_for` (= variant-id van het parent product), gezet bij het
 * toevoegen in snippets/product-roller-addon.liquid.
 * Reversibel: verwijder de <script>-include in layout/theme.liquid + dit bestand.
 */
(function () {
  var PROP = '_addon_for';
  var busy = false;

  function orphanKeys(cart) {
    if (!cart || !cart.items) return [];
    var present = {};
    cart.items.forEach(function (it) { if (it.quantity > 0) present[it.variant_id] = true; });
    var keys = [];
    cart.items.forEach(function (it) {
      var props = it.properties || {};
      var parent = props[PROP];
      if (parent && !present[Number(parent)]) keys.push(it.key);
    });
    return keys;
  }

  function removeKeys(keys, done) {
    if (!keys.length) { done(); return; }
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: keys[0], quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { removeKeys(keys.slice(1), done); })
      .catch(function () { done(); });
  }

  function refreshUI() {
    var ci = document.querySelector('cart-items');
    if (ci && typeof ci.refresh === 'function') {
      try { ci.refresh(); } catch (e) {}
    }
    // cart-icon-bubble los bijwerken (telt op de cart-pagina niet mee in ci.refresh)
    fetch('?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var b = document.getElementById('cart-icon-bubble');
        if (b && s && s['cart-icon-bubble']) b.innerHTML = s['cart-icon-bubble'];
      })
      .catch(function () {});
  }

  function reconcile(cart) {
    if (busy) return;
    var keys = orphanKeys(cart);
    if (!keys.length) return;
    busy = true;
    removeKeys(keys, function () {
      refreshUI();
      busy = false;
    });
  }

  function fetchAndReconcile() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(reconcile).catch(function () {});
  }

  // Elke line-item wijziging/verwijdering bubblet als on:line-item:change naar document.
  document.addEventListener('on:line-item:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.items) reconcile(cart); else fetchAndReconcile();
  });

  // Vangnet: ook na een algemene cart-refresh checken.
  document.addEventListener('on:cart:refresh', fetchAndReconcile);
})();
